var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{},[_c('b-tabs',{attrs:{"lazy":"","fill":"","Justified":""},on:{"activate-tab":_vm.changeTab}},[_c('b-tab',{attrs:{"title":"Quản lý QR"}},[_c('QR')],1),_c('b-tab',{attrs:{"title":"Quản lý QR VA"}},[_c('QRVA')],1)],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }